// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a13187dc","732":"ffb94db8","977":"30d8dc09"}[chunkId] + ".chunk.js";
};